import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "alertTypeInputs",
    "webhookInputs",
    "webhookVariables",
    "expirationInputs",
    "recordChangeInputs",
    "expirationWebhookVars",
    "singleExpirationWebhookVars",
    "websiteMonitorWebhookVars",
    "passwordViewWebhookVars",
    "recordChangeWebhookVars",
    "passwordChangeWebhookVars",
    "destinationHeading",
    "emailGroup"
  ]

  connect() {
    this.updateVisibility()
  }

  updateAlertTypeInputs() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selectedAlertType = this.getSelectedAlertType()
    this.showWebhookCheckbox()
    this.hideAllSections()
    this.hideAllWebhookVariables()

    switch (selectedAlertType) {
      case 'single_expiration':
        this.showTarget('expirationInputs')
        this.showTarget('singleExpirationWebhookVars')
        break
      case 'expiration':
        this.showTarget('expirationInputs')
        this.showTarget('expirationWebhookVars')
        break
      case 'record_change':
        this.showTarget('recordChangeInputs')
        this.showTarget('recordChangeWebhookVars')
        this.showWebhookInputs()
        break
      case 'website_monitor':
      case 'password_view':
      case 'password_change':
        if (selectedAlertType === 'website_monitor') {
          this.showTarget('websiteMonitorWebhookVars')
        } else if (selectedAlertType === 'password_view') {
          this.showTarget('passwordViewWebhookVars')
        } else if (selectedAlertType === 'password_change') {
          this.showTarget('passwordChangeWebhookVars')
        }
        break
    }

    if (selectedAlertType === 'record_change') {
      this.destinationHeadingTarget.classList.add('hidden')
      this.emailGroupTarget.classList.add('hidden')
    } else {
      this.destinationHeadingTarget.classList.remove('hidden')
      this.emailGroupTarget.classList.remove('hidden')
    }
  }

  getSelectedAlertType() {
    const checkedRadio = this.element.querySelector('input[name="alert[alert_type]"]:checked')
    return checkedRadio ? checkedRadio.value : null
  }

  hideAllSections() {
    const sections = this.element.querySelectorAll('.alert-type-section')
    sections.forEach(section => {
      section.classList.add('hidden')
    })
  }

  hideAllWebhookVariables() {
    const webhookSections = this.element.querySelectorAll('.webhook-vars-section')
    webhookSections.forEach(section => {
      section.classList.add('hidden')
    })
  }

  showTarget(targetName) {
    if (this[`${targetName}Target`]) {
      this[`${targetName}Target`].classList.remove('hidden')
    }
  }

  toggleWebhookInputs(event) {
    const useWebhook = event.target.checked
    this.webhookInputsTarget.classList.toggle('hidden', !useWebhook)
  }

  showWebhookCheckbox() {
    this.element.querySelector('#webhook_checkbox').classList.remove('hidden')

    // Show or hide the webhook inputs based on the checkbox state
    const useWebhook = this.element.querySelector('#alert_use_webhook').checked
    const webhookInputs = this["webhookInputsTarget"]
    if (webhookInputs) {
      if (useWebhook) {
        webhookInputs.classList.remove('hidden')
      } else {
        webhookInputs.classList.add('hidden')
      }
    }
  }

  showWebhookInputs() {
    this.element.querySelector('#webhook_checkbox').classList.add('hidden')
    if (this.webhookInputsTarget) {
      this.webhookInputsTarget.classList.remove('hidden')
    }
  }
} 